<template>
    <div>
                <div
                    class="mb-3"
                    v-for="i of (model.length / 3)"
                    :key="$utils.formatYYYYMMDDDDD(month, date) + '_' + (i - 1)"
                    >
                    <p class="fw-900">{{ trans.labels['calendar.course.' + (i - 1)] }}</p>
                    <div v-for="(item, index) in $utils.getVersesFromCsv(model[3 * (i - 1) + 1])" :key="$utils.formatYYYYMMDDDDD(month, date) + '_' + (i - 1) + '_v_' + index">
                        <div class="d-flex mb-3">
                            <div class="d-flex" v-if="auth_level >= 100">
                                <b-form-checkbox :id="$utils.keyForLog(date, i - 1, 'v', index)" v-model="user_log[$utils.keyForLog(date, i - 1, 'v', index)]" class="mr-1" size="lg" switch @change="toggleUserLog($utils.keyForLog(date, i - 1, 'v', index))"></b-form-checkbox>
                            </div>
                            <div>
                                <b-link :href="'https://my.bible.com/ja/bible/' + env.APP_BIBLE + '/' + model[3 * (i - 1) + 0] + '.' + item" target="_blank">
                                    {{ trans.labels['bible.book_abbr.' + model[3 * (i - 1) + 0]] }} {{ trans_p('labels', 'calendar.chapter', { num: item, }) }}
                                </b-link>
                            </div>
                        </div>
                    </div>
                    <div v-for="(item, index) in $utils.getUrlsFromCsv(model[3 * (i - 1) + 2])" :key="$utils.formatYYYYMMDDDDD(month, date) + '_' + (i - 1) + '_u_' + index">
                        <div class="d-flex mb-3">
                            <div class="text-nowrap pr-2">
                                ※{{ index + 1 }}
                            </div>
                            <div class="flex-grow-1">
                                <b-link :href="item" target="_blank">
                                    <link-prevue
                                        :url="item"
                                        cardWidth="100%"
                                        apiUrl="/api/v1/app/preview"
                                        >
                                        <template slot-scope="props">
                                            {{ props.title }}
                                        </template>
                                        <template slot="loading">
                                            <span>{{ trans.labels['btn.link'] }}</span>
                                        </template>
                                    </link-prevue>
                                </b-link>
                            </div>
                        </div>
                    </div>
                </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LinkPrevue from 'link-prevue'

import { getLinkPreview, getPreviewFromContent } from "link-preview-js"
//const linkPreviewGenerator = require("link-preview-generator")

export default {
    components: {
        LinkPrevue,
    },
    props: {
        model: {
            type: Array,
            required: true,
            default() {
                return []
            },
        },
        date: {
            type: Number,
            required: true,
            default() {
                return 0
            },
        },
        month: {
            type: String,
            required: true,
            default() {
                return ''
            },
        },
        user_log: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
    },
    data() {
        return {
            preview: {},
        }
    },
    computed: {
        ...mapGetters([
            'env',
            'auth_id',
            'auth_level',
            'auth_check',
            'trans',
            'trans_p',
        ])
    },
    async mounted() {},
    methods: {
        toggleUserLog (key) {
            this.$emit('change', key)
        },
    },
}
</script>

<style lang="scss" scoped>
tr {
    cursor: pointer;
}
</style>

